"use strict";

const { get } = require("jquery");
const config = require('../../../../../config/locales_json/packs/private/admin/companies.json');
const language = $('body').data("language");

// Class definition

var CompaniesDatatable = function() {
  // Private functions
  var _init = function() {
      var datatable = $('#kt_datatable_companies').KTDatatable({
          // datasource definition
          data: {
            type: 'remote',
            method: 'GET',
            source: {
              read: {
                url: '/admin/companies/get_companies_for_admin.json',
                method: 'GET',
                map: function(data) {
                  if(data.data.statusCode) {
                    Swal.fire({
                      text: getTranslationValue(config, [language, "CompaniesDatatable", "data", "Swalfire-error-text"], "Lo sentimos!, ")+data.data.message,
                      icon: "error",
                      buttonsStyling: false,
                      confirmButtonText: getTranslationValue(config, [language, "CompaniesDatatable", "data", "Swalfire-error-confirmButtonText"], "Aceptar"),
                      customClass: {
                          confirmButton: "btn btn-fj-purple"
                      }
                    });

                    return false;
                  }

                  const totalText = getTranslationValue(config, [language, "CompaniesDatatable", "data", "kt_subheader_total_Total"], " Total")
                  $("#kt_subheader_total").html(data.meta.total + totalText)

                  setTimeout(() => {
                    $('div#kt_datatable_companies .tp').tooltip('enable');
                  }, 2000);

                  return data.data
                }
              },
            },
            pageSize: 20,
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
          },

          // layout definition
          layout: {
              scroll: false, // enable/disable datatable scroll both horizontal and vertical when needed.
              footer: false, // display/hide footer
          },

          // column sorting
          sortable: true,

          pagination: true,

          translate: {
            records: {
              processing: getTranslationValue(config, [language, "CompaniesDatatable", "translate", "records-processing"], 'Cargando...'),
              noRecords: getTranslationValue(config, [language, "CompaniesDatatable", "translate", "records-noRecords"], 'No hay registros disponibles')
            },
            toolbar: {
              pagination: {
                items: {
                  default: {
                    first: getTranslationValue(config, [language, "CompaniesDatatable", "toolbar", "default-first"], 'Primero'),
                    prev: getTranslationValue(config, [language, "CompaniesDatatable", "toolbar", "default-prev"], 'Anterior'),
                    next: getTranslationValue(config, [language, "CompaniesDatatable", "toolbar", "default-next"], 'Siguiente'),
                    last: getTranslationValue(config, [language, "CompaniesDatatable", "toolbar", "default-last"], 'Último'),
                    more: getTranslationValue(config, [language, "CompaniesDatatable", "toolbar", "default-more"], 'Más páginas'),
                    input: getTranslationValue(config, [language, "CompaniesDatatable", "toolbar", "default-input"], 'Página number'),
                    select: getTranslationValue(config, [language, "CompaniesDatatable", "toolbar", "default-select"], 'Selecciona el tamaño de la página')
                  },
                  info: getTranslationValue(config, [language, "CompaniesDatatable", "toolbar", "info"], 'Mostrando {{start}} - {{end}} de {{total}} empresas')
                }
              }
            }
          },

          // columns definition
          columns: [{
              field: 'name',
              title: getTranslationValue(config, [language, "CompaniesDatatable", "columns", "name", "title"], 'Empresa'),
              width: 300,
              template: function(data) {
                var name = data.name;

                var output = '<div class="d-flex align-items-center">\
                  <div class="ml-5 cont-name-client">\
                    <div class="text-dark-75 font-weight-bolder font-size-lg mb-0">' + name + '</div>\
                  </div>\
                </div>';

                return output;
              },
          }, {
              field: 'Actions',
              title: getTranslationValue(config, [language, "CompaniesDatatable", "columns", "Actions", "title"], "Acciones"),
              sortable: false,
              width: 130,
              overflow: 'visible',
              autoHide: false,
              template: function(row) {
                if(row.counter_jobs > 0){
                  const viewRecruiters = getTranslationValue(config, [language, "CompaniesDatatable", "columns", "Actions", "row_counter_clients", "output_a_2"], "Ver Reclutadores");
                  const seeJobOffers = getTranslationValue(config, [language, "CompaniesDatatable", "columns", "Actions", "row_counter_clients", "output_a_1"], "Ver ofertas");

                  var output = '<div class="d-flex align-items-center container-actions-table">\
                    <a href="/admin/clientes/'+ row.slug +'/reclutadores" class="icon mr-6 tp" data-toggle="tooltip" data-theme="dark" title="'+viewRecruiters+'"><i class="icon-oferts fas fa-users"></i></a>\
                    <a href="/admin/clientes/'+ row.slug +'/ofertas" class="icon mr-6 tp" data-toggle="tooltip" data-theme="dark" title="'+seeJobOffers+'"><i class="icon-oferts fas fa-clipboard-list"></i></a>\
                  </div>';
                } else {
                  const viewRecruiters = getTranslationValue(config, [language, "CompaniesDatatable", "columns", "Actions", "else", "output_a_2"], "Ver Reclutadores");

                  var output = '<div class="d-flex align-items-center container-actions-table">\
                      <a href="/admin/empresas/'+ row.id +'/reclutadores" class="icon mr-6 tp" data-toggle="tooltip" data-theme="dark" title="'+viewRecruiters+'"><i class="icon-oferts fas fa-users"></i></a>\
                  </div>';
                }

                return output;
              }
          }],
          search: {
            input: $('#kt_subheader_company_search_form'),
          },
      });
  };

  return {
    // public functions
    init: function() {
        _init();
    },
  };
}();

jQuery(document).ready(function() {
    if($("#kt_datatable_companies").length > 0){
        CompaniesDatatable.init();
    }
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}
